import React from 'react';
import classNames from 'classnames';
import './input-field.scss';

class InputField extends React.Component {
  render() {
    const {
      label,
      message,
      name,
      onChange,
      isValid,
      errorMessage,
      onFocus,
      id,
      autoFocus,
      charLimit,
      value,
      isDisabled,
    } = this.props;
    const fieldClass = classNames('input-field', { error: !isValid });
    const inputMessage = isValid ? message : errorMessage;
    return (
      <div className={fieldClass}>
        <label htmlFor={name} className="label" aria-label={label}>
          <span aria-hidden="true">{label}</span>
        </label>
        <input
          type="text"
          name={name}
          aria-label={name}
          onChange={onChange}
          onFocus={onFocus}
          id={id}
          autoFocus={autoFocus}
          maxLength={charLimit}
          disabled={isDisabled}
          value={value}
        />
        <div className="message">{inputMessage}</div>
      </div>
    );
  }
}
export default InputField;
